import React, { useEffect, useState } from 'react'
import StepLineHistory from './stepLineHistory'
import StepTextHistory from './stepTextHistory'
import './history.css'
import { t } from 'i18next'

const History = (props) => {
  const data = props.data
  const [dataPrepared, setDataPrepared] = useState()
  const isOrderFinalized = props.isOrderFinalized

  const prepareData = () => {
    if (data) {
      data.sort((a, b) => a.validationOrder - b.validationOrder)
      // Add an extra property to show-up date time in appropriate format
      data.forEach((d) => {
        d._displayDateTime = ''
        if (d.dateTime) {
          d._displayDateTime = d.dateTime
        }
      })
      setDataPrepared(data)
    }
  }

  useEffect(() => {
    prepareData()
  }, [])

  return (
    <div className='valcde_history'>
      <div>
        <div className='valcde_nameHistory'>
          {dataPrepared && dataPrepared.length > 0 ? <StepTextHistory isStartPoint={true} /> : <div />}

          {dataPrepared ? (
            dataPrepared.map((d, i) => (
              <StepTextHistory key={'valcde_step_history_username_' + i} isStartPoint={false} data={[d.userName]} />
            ))
          ) : (
            <div />
          )}
        </div>

        <div className='valcde_lineHistory'>
          {dataPrepared && dataPrepared.length > 0 ? <StepLineHistory isStartPoint={true} /> : <div />}

          {dataPrepared ? (
            dataPrepared.map((d, i) => <StepLineHistory key={'valcde_step_history_type_' + i} type={d.signatureType} />)
          ) : (
            <div />
          )}

          {!isOrderFinalized ? <StepLineHistory isStartPoint={false} /> : <div />}
        </div>

        <div className='valcde_dateHistory'>
          {dataPrepared ? (
            <StepTextHistory
              isStartPoint={true}
              data={[t('7000101'), dataPrepared[0]?._displayDateTime.split(' ')[0]]}
            />
          ) : (
            ''
          )}

          {dataPrepared ? (
            dataPrepared.map((d, i) => (
              <StepTextHistory
                key={'valcde_step_history_datetime_' + i}
                data={[
                  i === 0 ? t('9500182') : isOrderFinalized ? t('9500184') : t('9500183'),
                  d._displayDateTime.split(' ')[0],
                ]}
                isStartPoint={false}
              />
            ))
          ) : (
            <div />
          )}
        </div>
      </div>
    </div>
  )
}

export default History
